import MenuToggle from './modules/MenuToggle'
import Carousel from './modules/Carousel'
import Click from './modules/Click'
import ScrollTop from './modules/ScrollTop'
import PrimaryMenu from './modules/PrimaryMenu'
import PrimaryMenuSlide from './modules/PrimaryMenuSlide'
import ItemNumber from './modules/ItemNumber'
import SideMenuToggle from './modules/SideMenuToggle'
import Calclator from './modules/Calculator'
import Product from './modules/Product'
import Licence from './modules/Licence'
import HeightMatch from './modules/HeightMatch'

window.addEventListener('load', () => {
  new MenuToggle()
  new Click()
  new Carousel()
  new ScrollTop()
  new PrimaryMenu()
  new PrimaryMenuSlide()
})

document,addEventListener('DOMContentLoaded', ()=> {
  new ItemNumber()
  const
    sideBar = document.querySelector(`[data-module="sidebar-cnt"]`),
    calcCont = document.querySelector(`[data-module="calclator-addsubtra"]`),
    productCont = document.querySelector(`[data-module="product-cnt"]`),
    licenceCont = document.querySelector(`[data-module="licence-cnt"]`),
    HeightCont =  document.querySelector(`[data-height="heightAdjust"]`)
  if(sideBar)  
    new SideMenuToggle()
  if(calcCont)
    new Calclator()
  if(productCont)
    new Product()
  if(licenceCont)
   new Licence()
  if(HeightCont)
    new HeightMatch()
})

// Mediaサイズ変更時のイベントテンプレート
var mql = window.matchMedia('(max-width:767px)');

function Event(e) {
  if (e.matches) {
    /* the viewport is 600 pixels wide or less */
  } else {
    /* the viewport is more than than 600 pixels wide */
  }
}

mql.addListener(Event);
Event(mql)